import { styled } from '@mui/material/styles';

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',

  width: '100%',
  marginBottom: '20px',
});

export const FileUrlContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',

  fontSize: '13px',
});
